import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-rounded-icon',
  imports: [],
  templateUrl: './rounded-icon.html',
  styleUrl: './rounded-icon.scss',
})
export class RoundedIcon {
  classNames = input('');
}
